async function pushNonInteractionEvent(eventCategory, eventAction, eventLabel) {
  if(window.location.hostname !== 'localhost') {
    window.dataLayer.push({ecommerce: undefined});
    window.dataLayer.push({
      event: 'ga.event',
      eventCategory: eventCategory,  //vždy stejné
      eventAction: eventAction, //proměné podle zadání uživatelem - pouze v angličtině napříč mutacemi
      eventLabel: eventLabel, //naše odpověď nabídky pro danou kombinaci. Máte nějaká číselná nebo interní označení?
      eventValue: undefined,
      eventNonInteraction: true,
      eventCallback: function(){ 
        window.dataLayer.push({
          eventNonInteraction: false,
        }); 
      } 
    });
  }
}

export default pushNonInteractionEvent;



// WEBPACK FOOTER //
// ./src/application/utils/ga/pushNonInteractionEvent.js